import React, { useEffect, useState } from "react";

const TimeLeft = (props) => {
  const [timeLeft, setTimeLeft] = useState(0);

  const calculateTimeLeft = () => {
    let difference = new Date(props.datetime) - new Date();
    let timeLeft = {};
    if (difference > 0) {
      let h = Math.floor((difference / (1000 * 60 * 60)) % 24);
      let m = Math.floor((difference / 1000 / 60) % 60);
      let s = Math.floor((difference / 1000) % 60);
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: h < 10 ? "0" + h : h,
        minutes: m < 10 ? "0" + m : m,
        seconds: s < 10 ? "0" + s : s,
      };
    }
    return timeLeft;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval, i) => {
    if (!timeLeft[interval]) {
      return;
    }
    timerComponents.push(
      <span key={interval}>
        {timeLeft[interval]}
        {i === Object.keys(timeLeft).length - 1 ? "" : <span className="sep">{":"}</span>}
      </span>
    );
  });
  return <span>{timerComponents.length ? timerComponents : <span>00:00:00:00</span>}</span>;
};

export default TimeLeft;
